import Http from './index';
import { serialize } from '@/util'

export const postAntenatal = (params = '') => Http.post(`/profile/${params.id}/note`, params.form)
export const myAntenatal = (params) => Http.get(`/profile/notes${serialize(params)}`)